import { useThdCustomer } from '@thd-olt-functional/customer-information';
import React from 'react';
import classNames from 'classnames';
import {
  useCommonContext,
  usePurchaseHistoryContext,
} from '../../../hooks/useContexts';
import { DateSelectionDropdown } from '../../shared/DateSelectionDropdown';
import { AddReceiptButton } from '../page-header/AddReceiptButton';
import { PurchaserSelect, SearchBy, SortAndSearchButton } from './index';

/**
DateSelectionDropdown does not render on mobile when no orders are returned
*/
export const SortAndSearch = () => {
  const { svocID } = useThdCustomer();
  const { isMobile } = useCommonContext();
  const {
    customerRole,
    customerType,
    dateSelectorValue,
    pHRequest,
    setDateSelectorValue,
    setPHRequest,
  } = usePurchaseHistoryContext();

  return (
    <>
      <div id="mobile-sort-search" className="sui-w-full md:sui-hidden">
        {isMobile && customerType === 'b2b' && (
          <div className="sui-flex sui-flex-col sui-gap-4 sui-mb-[24px] md:sui-mb-0">
            <SortAndSearchButton
              customerType={customerType}
              dateSelectorValue={dateSelectorValue}
              setDateSelectorValue={setDateSelectorValue}
              pHRequest={pHRequest}
              setPHRequest={setPHRequest}
              isMobile={isMobile}
            />
            <AddReceiptButton svocId={svocID} mobile />
          </div>
        )}
        {isMobile && customerType !== 'b2b' && (
          <div className="sui-flex sui-flex-col sui-mb-[24px] md:sui-mb-0">
            <DateSelectionDropdown
              label="View History From"
              dateSelectorValue={dateSelectorValue}
              setDateSelectorValue={setDateSelectorValue}
              setPHRequest={setPHRequest}
              enableFullWidth
            />
          </div>
        )}
      </div>
      {!isMobile && (
        <div
          id="desktop-sort-search"
          className={classNames('md:sui-flex lg:sui-flex', {
            'sui-w-full md:sui-gap-[32px] lg:sui-gap-[32px]':
              customerType === 'b2b',
            'md:sui-gap-[24px] lg:sui-gap-[24px]': customerType === 'b2c',
          })}
        >
          <div style={{ maxWidth: '214px' }}>
            <DateSelectionDropdown
              label="View History From"
              dateSelectorValue={dateSelectorValue}
              setDateSelectorValue={setDateSelectorValue}
              setPHRequest={setPHRequest}
              enableFullWidth
            />
          </div>
          <div>
            <PurchaserSelect
              customerRole={customerRole}
              customerType={customerType}
            />
          </div>
          <SearchBy
            customerType={customerType}
            pHRequest={pHRequest}
            setPHRequest={setPHRequest}
            isMobile={isMobile}
          />
        </div>
      )}
    </>
  );
};
